import React, { useEffect, useMemo, useRef, useState } from "react";
import { useRecommendations } from "./providers/RecommendationsProvider.js";

import { Recommendation } from "./components/Recommendation.js";
import { useTrackVisibility } from "./hooks/trackVisibility.js";

export const InfiniteScroll = () => {
	const { items, fetchMore, fetchingMore } = useRecommendations();
	const [bottomVisible, setBottomVisible] = useState(false);
	const filteredRecommendations = useMemo(() => items.filter(({ price }) => !!price) || [], [items]);

	useTrackVisibility(filteredRecommendations);

	useEffect(() => {
		const check = async () => {
			if (bottomVisible && !fetchingMore) {
				await fetchMore();
				setBottomVisible(false);
			}
		};
		check();
	}, [bottomVisible, filteredRecommendations]);

	const bottomRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				setBottomVisible(entry.isIntersecting);
			},
			{
				threshold: 0.4,
				root: null,
			},
		);

		if (bottomRef.current) {
			observer.observe(bottomRef.current);
		}
		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<div>
			<div
				className="relative flex justify-center flex-wrap gap-y-16 gap-x-8 md:gap-16 md:mr-0 pl-2"
				style={{ scrollbarWidth: "none" }}
			>
				{filteredRecommendations.map((recommendation) => {
					return <Recommendation key={recommendation.itemId} recommendation={recommendation} />;
				})}
				<div ref={bottomRef} className="absolute w-full min-h-[40vh] max-h-[40%] bottom-0 pointer-events-none"></div>
			</div>
		</div>
	);
};
